import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {withAuth} from "../AuthContext";
import Notification from "../Utils/Notification";
import {INFO} from "../../utils/constants";
import Error from "../Utils/Error";
import Cookies from 'universal-cookie';
import { decode } from 'html-entities';
import { textTranslation,shouldTranslateTo } from '../../utils/utils';

const cookies = new Cookies();

class ResetMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            error: {},
            showSignUp: false,
            resetMailData: null,
        };

        this.handleResetPassword = this.handleResetPassword.bind(this);
    }

    componentDidMount() {
        const language = shouldTranslateTo();
        const getPageText = (pageValue,languageValue) => {
            axios
            .get(`/api/page-text/${pageValue}/${languageValue}`)
            .then(response => {
                let pageText = response.data.map(textItem => {
                    return textItem.text;
                });
                this.setState({
                    resetMailData: pageText
                });
            })
            .catch(err => {
                console.log('Error getting page text: ', err);
            });
        }
        getPageText('reset-password',language);
    }

    handleResetPassword(e) {
        e.preventDefault();
        axios
            .post('/api/password/email', this.state)
            .then(() => {
                Notification({
                    type: INFO,
                    message: decode(this.state.resetMailData[6])
                })
                this.setState({ email: '' });
            })
            .catch(err => {
                this.setState({ error: err, showSignUp: true });
            });
    }

    render() {
        if (!this.state.resetMailData) {
            return null
        }
        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="text-black font-all-round font-size-34 font-weight-600 mb-2">{decode(this.state.resetMailData[0])}</h3>
                                <p className="text-black font-all-round font-size-16 font-weight-400">
                                    {decode(this.state.resetMailData[1])}
                                </p>
                                <div id="login">
                                    <form
                                        method="post"
                                        onSubmit={this.handleResetPassword}
                                    >
                                        <div className="row">
                                            <div className="col-12  form-group">
                                                <label className="text-black font-open-sans font-size-16 font-weight-400">{decode(this.state.resetMailData[2])}</label>
                                                <input
                                                    type="email"
                                                    className="form-control person-email"
                                                    placeholder={decode(this.state.resetMailData[3])}
                                                    name="email"
                                                    id="email"
                                                    required
                                                    value={this.state.email}
                                                    onChange={(e) => this.setState({ email: e.target.value })}
                                                />
                                            </div>
                                            {
                                                this.state.showSignUp &&
                                                <div className="d-flex">
                                                    <div>
                                                        <Error error={this.state.error}/>
                                                    </div>
                                                    <Link
                                                        to="signup"
                                                        className="text-black underline font-open-sans font-size-14 font-weight-700 forgot-password"
                                                    >
                                                        {decode(this.state.resetMailData[4])}
                                                    </Link>
                                                </div>
                                            }
                                            <div className="submit-btn mt-0">
                                                <button
                                                    className="btn btn-orange btn-block text-white font-open-sans font-weight-700"
                                                    type="submit"
                                                    name="submit"
                                                    id="submit"
                                                >{decode(this.state.resetMailData[5])}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(ResetMail));
